module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1398647"
    }
  }, [_c('b', [_vm._v("MINI REMOULADE CRAB CAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1399147"
    }
  }, [_c('b', [_c('i', [_vm._v("Crab cakes are a universal favorite. These luscious morsels can be prepared up to several hours ahead and refrigerated. Reheat just before serving.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1400447"
    }
  }, [_c('b', [_vm._v("Prep: 25 minutes      Bake: 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1400947"
    }
  }, [_vm._v("2 tablespoons butter or margarine")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1401247"
    }
  }, [_vm._v("1 small onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1401547"
    }
  }, [_vm._v("½ red pepper, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1402447"
    }
  }, [_vm._v("1 stalk celery, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1402847"
    }
  }, [_vm._v("¼ cup light mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1403747"
    }
  }, [_vm._v("1 tablespoon sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1404047"
    }
  }, [_vm._v("2 teaspoons grainy Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1404347"
    }
  }, [_vm._v("½ teaspoon freshly grated lemon peel")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1405347"
    }
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1406247"
    }
  }, [_vm._v("⅛ teaspoon ground red pepper (cayenne)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1407247"
    }
  }, [_vm._v("1 pound lump crabmeat, picked over")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1407547"
    }
  }, [_vm._v("1 cup fresh bread crumbs (about 2 slices bread) "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c39_r1#d7e1416347"
    }
  }, [_vm._v("Lemon Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1408347"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 10-inch skillet, melt butter over medium heat. Add onion, red pepper, and celery. Cook, stirring frequently, until vegetables are tender, about 10 minutes. Let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1410447"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In large bowl, stir mayonnaise, sour cream, mustard, lemon peel, salt, and ground red pepper until blended; stir in crabmeat and bread crumbs just until mixed. Cover and refrigerate 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1412147"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Meanwhile, prepare Lemon Sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1412847"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Preheat oven to 400°F. Lightly grease two cookie sheets. Drop level tablespoons crab mixture, pressing lightly, on prepared cookie sheets. Bake until golden brown, about 15 minutes. Top each crab cake with about ½ teaspoon lemon sauce. Serve hot. Makes about 50 mini crab cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1416347"
    }
  }, [_c('b', [_vm._v("LEMON SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e1416847"
    }
  }, [_vm._v("In small bowl, stir together "), _c('b', [_vm._v("¼ cup light mayonnaise, ¼ cup sour cream, 1 teaspoon freshly grated lemon peel, 1 tablespoon fresh lemon juice, pinch salt, ")]), _vm._v("and "), _c('b', [_vm._v("pinch ground red pepper (cayenne) ")]), _vm._v("until blended. Makes about ½ cup.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1421747"
    }
  }, [_vm._v("Each crab cake with sauce: About 28 calories, 2g protein, 1g carbohydrate, 2g fat (1g saturated), 12mg cholesterol, 71mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1423047"
    }
  }, [_c('b', [_vm._v("MAIN-DISH CRAB CAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e1423547"
    }
  }, [_vm._v("Prepare crab cakes but divide crab mixture into 8 portions, about ½ cup each, and shape each into a 3-inch cake. Place on greased cookie sheet. Bake until golden brown, about 20 minutes, gently turning cake over with spatula halfway through baking. Serve with Lemon Sauce, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1426647"
    }
  }, [_vm._v("Each crab cake: About 138 calories, 12g protein, 5g carbohydrate, 7g fat (3g saturated), 68mg cholesterol, 366mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb92cdb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c39_r1.vue
// module id = 183
// module chunks = 0